<template>
    <transition name="router-anim">
      <div>
        <section class="info-block-wrapper search">
         
          <div class="custom-alert">
            <strong>This section is used to upload a CSV file containing kit data. The uploaded data is stored in a table and later processed using a cron job to create new orders in WS WordPress automatically.</strong>
          </div>
          <div class="title search">
            <span>Import WS Kits from CSV</span>
          </div>
          <div class="input-div-wrap">
            <div class="input-wrap" >
              <input
                    type="text"
                    class="input"
                    v-validate="'required|max:50'"
                    placeholder="Source"
                    name="source"
                    maxlength="50"
                    v-model="source"
                />
              <div v-if="sourceError" class="validate-error-import">
                {{ sourceError }}
              </div>
            </div>
            <div class="input-wrap" >
              <input type="file" @change="handleFileChange" accept=".csv" ref="file">
              <a :href="sampleCsvPath" download="sample.csv" class="download-link">
                <img src="../../images/wssample/csv.svg" class="csv-icon" > Download Sample CSV
              </a>
            </div>
            <div>
                <button
                  class="btn btn-test search"
                  @click="generateQrcode"
                  :disabled="!isFileSelected || !source.trim()"
                >Import
                </button>
            </div>
            <div class="input-wrap " >
              <span class="validate-error-import" v-if="showError">
                Kit import failed:  
                <span v-for="(row, rowIndex) in errorval" :key="rowIndex" >
                  <span v-if="row.length > 0">
                    In Row {{ rowIndex+1 }} - 
                  </span>
                  
                  <span v-for="(element, colIndex) in row" :key="colIndex">
                         {{element}}<span v-if="colIndex < row.length -1">,&nbsp;</span><span v-else>.&nbsp;</span>
                  </span>
                <br>
                &nbsp;
                <br>
                </span>
              </span> 
              <span class="success-msg" v-if="succesmsg != null">
                {{ succesmsg }}
              </span> 
            </div>
          </div>
        </section>
      </div>
    </transition>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import axios from "axios";
  export default {
    name: "AddWsCSV",
    data() {
      return {
        sampleCsvPath: "/wssample/sample.csv",
        csvFile: null,
        errorval: [],
        succesmsg: null,
        isFileSelected: false, // Initial state is disabled,
        showError: false,
        source: "", // Added source field
        sourceError: null, // Error message for source validation
      };
    },
    methods: {
      ...mapActions(["wcKitCsv"]),
      handleFileChange() {
        // Update selected file and enable the button
        this.isFileSelected = true;
      },
      generateQrcode() {
        const formData = new FormData();
        const blod = new Blob([this.$refs.file.files[0]], { type: "text/csv" });
        formData.append("csvFile", blod);
        this.wcKitCsv({ source: this.source, data: formData }).then(res => {
          if(res.error) {
            this.errorval = res.error;
            this.errorval.forEach(element => {
              element.map(data => {
                if(data.length > 0){
                  this.showError = true;
                }
              });
            });
            this.succesmsg = null;
          } else {
            this.succesmsg = res.success;
            this.errorval = null;
            this.showError = false;
          }
        })
      },
    },
    
  };
  </script>
  
  <style scoped lang="scss">
  @import "../../styles/colors";
  .kits {
    margin: 50px 0 0 0;
  }
  .kits-title {
    display: flex;
    justify-content: space-between;
    margin: 0 0 20px 0;
    padding: 0 30px;
  }
  .title {
    color: #b3b3b3;
    font-size: 12px;
    font-family: TTNormsMedium, sans-serif;
  }
  .title.id {
    min-width: 120px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.id {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
    cursor: pointer;
    transition: all 0.5s linear;
  }
  .kit-desc.id:hover {
    color: #005eb8;
    font-family: TTNormsRegular, sans-serif;
  }
  .title.status {
    min-width: 170px;
    width: 100%;
    max-width: 170px;
  }
  .kit-desc.status {
    min-width: 170px;
    width: 100%;
    max-width: 170px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .title.first-name {
    min-width: 130px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.first-name {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .title.last-name {
    min-width: 130px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.last-name {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .title.email {
    min-width: 190px;
    width: 100%;
    max-width: 190px;
  }
  .kit-desc.email {
    min-width: 190px;
    width: 100%;
    max-width: 190px;
    overflow: hidden;
    padding: 0 5px 0 0;
  }
  .kit-desc.email span {
    width: 100%;
    max-width: 180px;
    overflow: hidden;
    display: inline-block;
  }
  .kit-desc.first-name span,
  .kit-desc.last-name span {
    width: 100%;
    max-width: 140px;
    overflow: hidden;
    display: inline-block;
  }
  .title.phone {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.phone {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .title.date {
    min-width: 100px;
    width: 100%;
    position: relative;
  //   cursor: pointer;
    max-width: 180px;
  }
  .title.date2 {
    min-width: 160px;
    width: 100%;
    position: relative;
  //   cursor: pointer;
  }
  .title.date img {
    max-width: 7px;
    height: 14px;
    position: absolute;
    top: -3px;
    right: 5px;
  }
  .title.date .down {
    transform: rotate(180deg);
  }
  .kit-desc.date {
    min-width: 160px;
    width: 100%;
  }
  .kit-desc.button {
    min-width: 160px;
    width: 100%;
  }
  .kits-item {
    justify-content: space-between;
    position: relative;
    align-items: center;
    padding: 25px 30px;
    background-color: #fff;
    margin: 10px 0;
    border-radius: 5px;
  }
  .kits-item.custom {
    text-align: center;
    display: ruby block;
  }
  .btn-align {
    margin-top: 20px;
    text-align: center;
    display: block ruby;
  }
  .kits-item:hover {
    background-color: #e0e9f4;
  }
  .kits-item:hover .remove-kit-btn {
    display: block;
  }
  .kit-desc {
    color: #58595b;
    font-size: 12px;
    font-family: TTNormsLight, sans-serif;
  }
  .status-line {
    width: 100%;
    max-width: 140px;
    height: 3px;
    background-color: rgba(0, 70, 173, 0.3);
    margin: 5px 0 0 0;
    position: relative;
  }
  .status-line-bg {
    position: absolute;
    width: 50%;
    content: "";
    left: 0;
    top: 0;
    height: 100%;
    background-color: #005eb8;
  }
  .pogination {
    margin: 20px 0 0 0;
  }
  .remove-icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    padding: 0;
  }
  .onhold-btn {
    background-color: transparent;
    border: none;
    padding: 0;
    max-width: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    margin: 0 0 0 5px;
    cursor: pointer;
  }
  .onhold-btn-img {
    max-width: 100%;
  }
  .onHoldStatus {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .remove-kit-btn {
    display: none;
    position: absolute;
    width: 20px;
    height: 20px;
    border: 1px solid #58595b;
    border-radius: 5px;
    right: 20px;
    cursor: pointer;
    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      height: 1px;
      width: 13px;
      background-color: #58595b;
      top: 50%;
      left: 50%;
      transform: translate(-50%) rotate(45deg);
    }
    &:after {
      transform: translate(-50%) rotate(-45deg);
    }
    &:hover {
      border-color: red;
      &:before,
      &:after {
        background-color: red;
      }
    }
  }
  @media print {
    .kits {
      display: none;
    }
  }
  .btn {
    align-items: center;
    justify-content: center;
    outline: none;
    border: 1px solid transparent;
    font-size: 12px;
    font-family: 'TTNormsLight, sans-serif';
    padding: 6px 15px 6px 15px;
    height: 30px;
    margin: 0 0 0 13px;
    cursor: pointer;
    border-radius: 5px;
  }
  .btn.search {
    height: 35px;
    min-width: 440px;
    margin: 0px;
  }
  .btn-test {
    background-color: #005eb8;
    color: #fff;
    max-width: 160px;
    width: 100%;
  }
  .title {
    color: #1052b2;
    padding: 20px 0 0 0;
    font-size: 16px;
    font-family: TTNormsMedium, sans-serif;
    margin: 0 0 30px 0;
    display: flex;
    position: relative;
    justify-content: space-between;
  }
  .title.search {
    font-size: 20px;
    margin: 0 0 20px 0;
    display: inherit;
    padding: 0px;
  }
  .kit-input {
    padding: 0px 5px;
    border: 1px solid transparent;
    outline: none;
    color: #231f20;
    font-size: 14px;
    margin: 0 0 0 5px;
    display: inline-block;
    max-width: 200px;
    width: 100%;
    transition: border 0.3s linear;
    font-family: TTNormsLight, sans-serif;
  }
  .kit-input.input {
    text-align: center;
  }
  .item {
    margin: 0 0 25px 0;
    position: relative;
  }
  .item-title {
    margin: 0 0 14px 0;
    color: #000;
    font-size: 12px;
    font-family: TTNormsMedium, sans-serif;
  }
  .item-val {
    color: #000;
    font-size: 14px;
    font-family: TTNormsLight, sans-serif;
    position: relative;
  }
  .date-wrap {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d9d9d9;
  }
  .date-wrap2 {
    display: flex;
    justify-content: space-between;
  }
  .margin-10 {
    margin-top: 10px;
  }
  .info-block-wrapper {
    width: 100%;
    min-height: 200px;
    box-sizing: border-box;
    padding: 40px 30px;
    display: block;
    justify-content: space-between;
    background-color: $white;
    border-radius: 15px;
    box-shadow: 0 3px 15px -9px $boxShadow;
    font-family: TTNormsRegular, sans-serif;
    color: $gray;
    margin: 10px 0;
    position: relative;
  }
  .info-block-wrapper.search {
    text-align: center;
  }
  .input {
    width: 440px;
    padding: 12px 30px;
    border-radius: 10px;
    border: 1px solid #c5c5c5;
    color: $gray;
    font-size: 16px;
    text-align: center;
    outline: none;
    font-family: TTNormsMedium, sans-serif;
  }
  .textarea {
    width: 100%;
    min-height: 150px;
    padding: 12px 13px;
    border-radius: 10px;
    border: 1px solid #c5c5c5;
    color: $gray;
    font-size: 16px;
    outline: none;
    font-family: TTNormsMedium, sans-serif;
  }
  .input::placeholder {
    color: $lightGray;
    font-size: 16px;
    text-align: center;
    text-transform: none;
    font-family: TTNormsMedium, sans-serif;
  }
  .input-wrap {
    margin-bottom: 25px;
    position: relative;
  }
  .input.invalid {
    border: 1px solid $red;
  }
  .position {
    position: initial;
  }
  .btn:disabled {
    cursor: default;
    opacity: 0.5;
  }
  .or-text {
    font-size: 15px;
  }
  .radio-span {
    margin-right: 35px;
  }
  .img-wrap {
    margin-top: 20px;
    display: inline-block;
  }
  .input.custom-lower-case {
    text-transform: none;
  }
  .download-btn {
    margin-top: 20px;
  }
  .qrcode-wrap {
    padding-left: 16%;
  }
  
  .file-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .file-info {
    margin-top: 10px;
    border: 1px solid #ccc;
    padding: 10px;
  }
  
  /* Loading animation */
  @keyframes spinner {
    to { transform: rotate(360deg); }
  }
  
  button span {
    display: inline-block;
  }
  
  button[disabled] span:first-child {
    visibility: hidden;
  }
  .success-msg {
    color: green;
    font-size: 14px;
    font-family: TTNormsLight, sans-serif;
    bottom: -15px;
    display: inline-block;
    left: 0;
    height: 100%;
    width:100%;
    text-align: center;
    padding-top:10px;
  }
  .validate-error-import {
    color: $red;
    font-size: 13px;
    font-family: TTNormsLight, sans-serif;
    display: inline-block;
    height: 100%;
    width:100%;
    text-align: center;
    padding-top:10px;
  }
  
  .input-wrap-custom {
   height: auto;
  }
  .csv-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .description-modal{
    text-align: start;
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 9990;
  }
  .custom-alert {
    text-align: start;
    background-color: #d4edda;
    color: #155724;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #c3e6cb;
    font-family: TTNormsLight, sans-serif;
    margin-bottom: 20px;
  }
  </style>
  